import { render } from "./CIS-Masthead-Two-Column.vue?vue&type=template&id=2c8af5e6&scoped=true"
import script from "./CIS-Masthead-Two-Column.vue?vue&type=script&lang=js"
export * from "./CIS-Masthead-Two-Column.vue?vue&type=script&lang=js"

import "./CIS-Masthead-Two-Column.vue?vue&type=style&index=0&id=2c8af5e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c8af5e6"]])

export default __exports__